import type { PropsWithChildren } from "react";

export function Card({ children }: PropsWithChildren) {
  return (
    <article className="rounded-lg border border-line bg-white p-6 shadow-card">
      {children}
    </article>
  );
}
